import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import { ANNUAL } from '@anm/constants/subscription';
import roundPrice from '@anm/helpers/pricing/roundPrice';
import { useCallback, useState } from 'react';

export const useCardViewChanger = (showEditCardDefault?: boolean) => {
  const [showEditCard, setEditCardShow] = useState(!!showEditCardDefault);
  const handleCardChangeToEditView = useCallback(
    () => setEditCardShow(true),
    []
  );

  return [showEditCard, handleCardChangeToEditView] as const;
};

type PricePredictionProps = {
  period: SubscriptionPeriod;
  annualPrice: number;
  monthlyPrice: number;
};
export const usePricePrediction = ({
  period,
  annualPrice,
  monthlyPrice
}: PricePredictionProps) => {
  const fullAnnualPrice = monthlyPrice * 12;
  const isSelectedAnnual = period === ANNUAL;
  const selectedPlanPrice = roundPrice(
    isSelectedAnnual ? annualPrice : monthlyPrice
  );
  const selectedFullPlanPrice = roundPrice(
    isSelectedAnnual ? fullAnnualPrice : monthlyPrice
  );

  const annualDiscount = isSelectedAnnual
    ? roundPrice(fullAnnualPrice - annualPrice)
    : undefined;

  return [selectedFullPlanPrice, annualDiscount, selectedPlanPrice] as const;
};
